<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import productList from "./product-list";
    export default {
    components: { Layout, PageHeader, productList },
    data() {
        return {};
    }
    };

</script>

<template>
  <Layout>
    <product-list/>
  </Layout>
</template>